import React, {useEffect, useState} from 'react';
import {callApi} from "../../../connection/ClientApi";
import Urls from "../../../connection/Urls";
import queryString from 'query-string';
import messages from "res/messages/farsi";
import {Box, Divider, Tab, Tabs} from "@material-ui/core";
import Stepper from "components/stepper/Stepper";
import TabPanel from "components/tab/TabPanel";
import KeyValueTable from "../../../components/table/KeyValueTable";
import TitleProductList from "../dynamicLict/TitleProductList";
import {IsLP_MP_SP, IsLP_MP_SP_T, IsNotLP_MP_SP, IsT} from "my-styles/media/media";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import TitleValue from "components/textValue/TitleValue";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import ThumbnailGellery from "../../../components/thumbnailGallery/ThumbnailGellery";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import {Animated} from "react-animated-css";
import {useHistory} from "react-router-dom";
import StandardButton from "../../../components/buttons/StandardButton";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation, Pagination} from "swiper";
import {authenticationViewModel} from "../../../viewModels/Authentication.viewModel";
import MetaTags from 'react-meta-tags';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'

import ICNotifications from '@material-ui/icons/NotificationsActiveOutlined';
import ICMuteNotifications from '@material-ui/icons/NotificationsOffOutlined';
import ICShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import ICTagBlue from "res/images/tag_blue.png";
import ICTag from "res/images/tag.png";
import ICAddIcon from "res/images/add.png";
import ICRemoveIcon from "res/images/remove.png";
import Score from "./Score";
import Comments from "./Comments";
import StarIcon from "@mui/icons-material/Star";
import { Helmet } from 'react-helmet';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

SwiperCore.use([Navigation])

export default function ProductDetail(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [product, setProduct] = useState()
    const [relatedProducts, setRelatedProducts] = useState([])
    const [tab, setTab] = React.useState(0)
    const [notifyStatus, setNotifyStatus] = useState(product ? product.notify_status : false)
    const [isInBasket, setIsInBasket] = useState(false)
    const [basketCount, setBasketCount] = useState(0)
    const [plusProgressIsShow, setPlusProgressIsShow] = useState(false)
    const [minusProgressIsShow, setMinusProgressIsShow] = useState(false)
    const [productComments, setProductComments] = useState([])

    const onTabChange = (event, newValue) => {
        setTab(newValue)
    }

    const onBrandClicked = () => {
        if (product.category_id !== "-1" && product.manufacturer) {
            props.onNavigate(history, "/category?m=" + product.manufacturer_id + "&p=1")
        }
    }

    const onCategoryClicked = () => {
        props.onNavigate(history, "/category?c=" + product.category_id + "&p=1")
    }

    function requestProductDetail(onSuccess) {
        let params = new FormData()
        params.append("product_id", urlParams.v)
        callApi(Urls.getProductDetail, params, (data) => {
            if (data && data.product_data) {
                if (data.product_data) {
                    let products = basketViewModel.checkLocalBasket(data.product_data)
                    let imageConst = 4
                    if (IsT()) {
                        imageConst = 3
                    }
                    let imageCount = products[0].images.length
                    if (imageCount < imageConst) {
                        for (let i = 0; i < imageConst - imageCount; i++) {
                            products[0].images.push("")
                        }
                    }

                    setNotifyStatus(products[0].notify_status !== 0)
                    setBasketCount(products[0].basket_count)
                    setIsInBasket(products[0].basket_added)

                    setProduct(products[0])
                    onSuccess(products[0])
                }
                if (data.related_product) {
                    setRelatedProducts(basketViewModel.checkLocalBasket(data.related_product))
                }
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
            setProduct(undefined)
            setRelatedProducts([])
        }, () => {
            props.onLoading(true)
        }, () => {
            props.onLoading(false)
        })
    }

    function requestNotifyProduct() {
        if (authenticationViewModel.isLogin) {
            let params = new FormData()
            params.append("product_id", product.product_id)
            callApi(Urls.notifyAvailableProduct, params, () => {
                setNotifyStatus(!notifyStatus)
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                props.onLoading(true)
            }, () => {
                props.onLoading(false)
            })
        } else {
            props.onShowLogin({
                showLogin: true,
                goToLogin: () => {
                    props.onNavigate(history, "/login")
                }
            })
        }
    }

    function gallery() {
        if (product && product.images.length > 0) {
            return <div className="card marginSmall inPc25InTablet33InMobilePhablet100 ">
                <div className="marginSmall">
                    <ThumbnailGellery
                        key={Math.random()}
                        itemPerView={IsT() ? 3 : 4}
                        items={product.images}/>
                </div>
            </div>
        }
    }

    function detailLarge() {
        if (product) {
            return <div className="inPc75InTablet67InMobilePhablet100 marginSmall card paddingSmall">
                <div className="largeTextBold">
                    {product.name}
                </div>
                <TitleValue
                    onClick={product.manufacturer ? onBrandClicked : undefined}
                    className="marginLeftRightSmall marginTopBottomMedium"
                    title={messages.brand}
                    titleClassName="mediumText"
                    value={product.manufacturer ? product.manufacturer : "-"}
                    valueClassName="mediumTextBold"/>

                {productComments && productComments.score>0 ? <div>
                    <TitleValue
                        className="marginLeftRightSmall marginTopBottomMedium"
                        title=" "
                        titleClassName="mediumText"
                        value={ <span className={"flex-align-center"} style={{marginRight:'-15px'}}>

                            <StarIcon style={{fill: '#f9a825'}}/> <p>  </p>  {productComments.score}   از   {productComments.count} دیدگاه   </span>}
                        valueClassName="mediumTextBold"/>


                </div> : <div></div>}

                <TitleValue
                    className="marginLeftRightSmall marginTopBottomSmall"
                    title={messages.category}
                    titleClassName="mediumText"
                    value={product.category_name !== "-1" ? product.category_name : "-"}
                    valueClassName="mediumTextBold"/>
                <Divider style={{marginTop: "4em"}}/>
                <table>
                    <tbody>
                    <tr>
                        {product.limit_count > 0 ?
                            <td>
                                <TitleValue
                                    title={messages.price}
                                    titleClassName="largeTextBold"
                                    value={product.price}
                                    valueClassName={product.special_price > 0 ?
                                        "textUnderlined grayColor largeTextBold" :
                                        "textNotUnderlined blueColor_2 largeTextBold"}
                                    secondValue={product.special}
                                    secondValueClassName={"blueColor_2 largeTextBold"}/>
                            </td> :
                            <td className="fullWidth">
                                <div className="paddingSmall pinkColor mediumTextBold">
                                    {messages.productNotExist}
                                </div>
                            </td>
                        }

                        {product.limit_count > 0 &&
                            <td className="fullWidth">
                                <div className="horizontalScreen">
                                    {product.is_old_price > 0 &&
                                        <div style={{position: "relative"}} className="largeIcon center">
                                            <img src={ICTagBlue} className="full" alt=""/>
                                            <label className="whiteColor smallText productDetailTag">
                                                {messages.oldPrice}
                                            </label>
                                        </div>
                                    }
                                    {product.discount_percent > 0 &&
                                        <div style={{position: "relative"}} className="largeIcon center">
                                            <img src={ICTag} className="full" alt=""/>
                                            <label className="whiteColor mediumText productDetailTag">
                                                {product.discount_percent}%
                                            </label>
                                        </div>
                                    }
                                </div>
                            </td>
                        }

                        {IsLP_MP_SP() &&
                            <>
                                {product.limit_count > 0 ?
                                    <>
                                        {isInBasket ?
                                            <td>
                                                <Animated
                                                    animationIn="slideInDown"
                                                    animationInDuration={500}
                                                    isVisible={isInBasket}>
                                                    <div style={{width: "10em"}} className="center horizontalScreen">
                                                        <StandardButton
                                                            loading={plusProgressIsShow}
                                                            icon={<img className={'xxSmallIcon'} src={ICAddIcon}
                                                                       alt={"صرفه مارکت"}/>}
                                                            onClick={() => {
                                                                if (basketCount >= product.limit_count) {
                                                                    props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                                                                } else {
                                                                    basketViewModel.plusToBasket(product, () => {

                                                                    }, () => {

                                                                    }, () => {
                                                                        setPlusProgressIsShow(true)
                                                                    }, () => {
                                                                        setPlusProgressIsShow(false)
                                                                    })
                                                                }
                                                            }}/>
                                                        <label style={{width: "40%"}}
                                                               className="marginTopSmall center largeTextBold blueColor_2">
                                                            {basketCount}
                                                        </label>
                                                        <StandardButton
                                                            loading={minusProgressIsShow}
                                                            icon={<img className={'xxSmallIcon'} src={ICRemoveIcon}
                                                                       alt={"صرفه مارکت"}/>}
                                                            onClick={() => {
                                                                basketViewModel.removeFromBasket(product, () => {

                                                                }, () => {

                                                                }, () => {
                                                                    setMinusProgressIsShow(true)
                                                                }, () => {
                                                                    setMinusProgressIsShow(false)
                                                                })
                                                            }}/>
                                                    </div>
                                                </Animated>
                                            </td> :
                                            <td>
                                                <Animated
                                                    animationIn="slideInDown"
                                                    animationInDuration={500}
                                                    isVisible={!isInBasket}>
                                                    <IconTitleButtonRound
                                                        backgroundcolor={"var(--red_3)"}
                                                        height={"3em"}
                                                        width={"100%"}
                                                        direction="ltr"
                                                        fontSize="mediumTextBold"
                                                        onClick={() => {
                                                            if (product.basket_count >= product.limit_count) {

                                                            } else {
                                                                basketViewModel.addToBasket(product, () => {

                                                                }, () => {

                                                                }, () => {
                                                                    props.onLoading(true)
                                                                }, () => {
                                                                    props.onLoading(false)
                                                                })
                                                            }
                                                        }}
                                                        icon={<ICShoppingCartIcon
                                                            className={'whiteColor'}
                                                            fontSize={"small"}/>}
                                                        title={messages.addToBasket}/>
                                                </Animated>
                                            </td>
                                        }
                                    </> :
                                    <>
                                        {notifyStatus ?
                                            <td>
                                                <Animated
                                                    animationIn="slideInDown"
                                                    animationInDuration={500}
                                                    isVisible={!isInBasket}>
                                                    <IconTitleButtonRound
                                                        backgroundcolor={"var(--gray_4)"}
                                                        height={"3em"}
                                                        width={"100%"}
                                                        direction="ltr"
                                                        fontSize="mediumTextBold"
                                                        onClick={() => {
                                                            requestNotifyProduct()
                                                        }}
                                                        icon={<ICMuteNotifications className={'whiteColor'}
                                                                                   fontSize={"small"}/>}
                                                        title={messages.dontNotifyMe}/>
                                                </Animated>
                                            </td> :
                                            <td>
                                                <Animated
                                                    animationIn="slideInDown"
                                                    animationInDuration={500}
                                                    isVisible={!isInBasket}>
                                                    <IconTitleButtonRound
                                                        backgroundcolor={"var(--orange_1)"}
                                                        height={"3em"}
                                                        width={"100%"}
                                                        direction="ltr"
                                                        fontSize="mediumTextBold"
                                                        onClick={() => {
                                                            requestNotifyProduct()
                                                        }}
                                                        icon={<ICNotifications className={'whiteColor'}
                                                                               fontSize={"small"}/>}
                                                        title={messages.notifyMe}/>
                                                </Animated>
                                            </td>
                                        }
                                    </>
                                }
                            </>
                        }

                    </tr>
                    </tbody>
                </table>
                {IsNotLP_MP_SP() ?
                    <div className="marginSmall" style={{float: "left"}}>
                        {product.limit_count > 0 ?
                            <>
                                {isInBasket ?
                                    <div>
                                        <Animated
                                            animationIn="slideInDown"
                                            animationInDuration={500}
                                            isVisible={isInBasket}>
                                            <div style={{width: "10em"}} className="center horizontalScreen">
                                                <StandardButton
                                                    loading={plusProgressIsShow}
                                                    icon={<img className={'xxSmallIcon'} src={ICAddIcon} alt={"صرفه مارکت"}/>}
                                                    onClick={() => {
                                                        if (basketCount >= product.limit_count) {
                                                            props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                                                        } else {
                                                            basketViewModel.plusToBasket(product, () => {

                                                            }, () => {

                                                            }, () => {
                                                                setPlusProgressIsShow(true)
                                                            }, () => {
                                                                setPlusProgressIsShow(false)
                                                            })
                                                        }
                                                    }}/>
                                                <label style={{width: "40%"}}
                                                       className="center largeTextBold blueColor_2 marginTopSmall">
                                                    {basketCount}
                                                </label>
                                                <StandardButton
                                                    loading={minusProgressIsShow}
                                                    icon={<img className={'xxSmallIcon'} src={ICRemoveIcon} alt={"صرفه مارکت"}/>}
                                                    onClick={() => {
                                                        basketViewModel.removeFromBasket(product, () => {

                                                        }, () => {

                                                        }, () => {
                                                            setMinusProgressIsShow(true)
                                                        }, () => {
                                                            setMinusProgressIsShow(false)
                                                        })
                                                    }}/>
                                            </div>
                                        </Animated>
                                    </div> :
                                    <div>
                                        <Animated
                                            animationIn="slideInDown"
                                            animationInDuration={500}
                                            isVisible={!isInBasket}>
                                            <IconTitleButtonRound
                                                backgroundcolor={"var(--red_3)"}
                                                height={"3em"}
                                                width={"100%"}
                                                direction="ltr"
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    if (product.basket_count >= product.limit_count) {

                                                    } else {
                                                        basketViewModel.addToBasket(product, () => {

                                                        }, () => {

                                                        }, () => {
                                                            props.onLoading(true)
                                                        }, () => {
                                                            props.onLoading(false)
                                                        })
                                                    }
                                                }}
                                                icon={<ICShoppingCartIcon
                                                    className={'whiteColor'}
                                                    fontSize={"small"}/>}
                                                title={messages.addToBasket}/>
                                        </Animated>
                                    </div>
                                }
                            </> :
                            <>
                                {notifyStatus ?
                                    <div>
                                        <Animated
                                            animationIn="slideInDown"
                                            animationInDuration={500}
                                            isVisible={!isInBasket}>
                                            <IconTitleButtonRound
                                                backgroundcolor={"var(--gray_4)"}
                                                height={"3em"}
                                                width={"100%"}
                                                direction="ltr"
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    requestNotifyProduct()
                                                }}
                                                icon={<ICMuteNotifications className={'whiteColor'}
                                                                           fontSize={"small"}/>}
                                                title={messages.dontNotifyMe}/>
                                        </Animated>
                                    </div> :
                                    <div>
                                        <Animated
                                            animationIn="slideInDown"
                                            animationInDuration={500}
                                            isVisible={!isInBasket}>
                                            <IconTitleButtonRound
                                                backgroundcolor={"var(--orange_1)"}
                                                height={"3em"}
                                                width={"100%"}
                                                direction="ltr"
                                                fontSize="mediumTextBold"
                                                onClick={() => {
                                                    requestNotifyProduct()
                                                }}
                                                icon={<ICNotifications className={'whiteColor'}
                                                                       fontSize={"small"}/>}
                                                title={messages.notifyMe}/>
                                        </Animated>
                                    </div>
                                }
                            </>
                        }
                    </div> :
                    <Divider/>
                }
                {IsLP_MP_SP() && categoryPath()}
            </div>
        }
    }

    function categoryPath() {
        if (product && product.parent_category_id) {
            return <div>
                <Stepper items={[
                    {
                        id: product.parent_category_id,
                        title: product.parent_category_name,
                        image: product.parent_category_image,
                        onClick: onCategoryClicked
                    },
                    {
                        id: product.category_id,
                        title: product.category_name,
                        image: product.category_image,
                        onClick: onCategoryClicked
                    }
                ]}/>
            </div>
        }
    }

    function tabs() {
        if (product) {
            let rows = [{
                name: messages.brand,
                value: product.manufacturer ? product.manufacturer : "-",
            }, {
                name: messages.category,
                value: product.category_name !== '-1' ? product.category_name : "-",
            }, {
                name: messages.oldPrice,
                value: product.is_old_price ? messages.is : messages.isNot,
                textcolor: product.is_old_price ? "var(--green_3)" : undefined
            }, {
                name: messages.status,
                value: product.limit_count > 0 ? messages.exist : messages.notExist,
                textcolor: product.limit_count > 0 ? "var(--green_3)" : "var(--red_1)"
            }]
            if (product.attribute_groups) {
                for (let attributeGroup of product.attribute_groups) {
                    rows.push({
                        name: attributeGroup.name,
                        value: attributeGroup.text
                    })
                }
            }
            return <div className="card marginSmall" style={{minHeight: "15em"}}>
                <Box>
                    <Box style={{borderBottom: 1, borderColor: 'divider'}}>
                        <Tabs value={tab} onChange={onTabChange} aria-label="basic tabs example">
                            <Tab label={messages.productDetail} {...a11yProps(0)} />
                            {product.description &&
                            <Tab label={messages.productDescription} {...a11yProps(1)} />
                            }
                        </Tabs>
                        <Divider/>
                    </Box>
                    <TabPanel style={{padding: "1em"}} value={tab} index={0}>
                        <KeyValueTable rows={rows}/>
                    </TabPanel>
                    <TabPanel style={{padding: "1em"}} value={tab} index={1}>
                        {(product && product.description && product.description.includes("\r\n")) ?
                            <div className="fullWidth">
                                {product.description.split("\r\n").map((description, index) => {
                                    return <div key={index}>
                                        {description}
                                    </div>
                                })}
                            </div> :
                            <div className="fullWidth">
                                {product.description}
                            </div>
                        }
                    </TabPanel>
                </Box>
            </div>
        }
    }

    function related() {
        if (relatedProducts && relatedProducts.length > 0) {
            return <div className="center marginSmall"
                        style={{marginTop: "1em", height: IsLP_MP_SP() ? 400 : 330}}>
                <TitleProductList
                    {...props}
                    products={relatedProducts}
                    header={{
                        title: messages.relatedProducts
                    }}
                    onAllClicked={() => {

                    }}/>
            </div>
        }
    }

    function largeView() {

        if (product) {
            return <div className="fullWidth">
                <div className="horizontalScreen">
                    {gallery()}
                    {detailLarge()}
                </div>
                {IsT() &&
                    <div className="card marginSmall" style={{width: "98%"}}>
                        {categoryPath()}
                    </div>
                }
                {tabs()}
                {related()}

                {productComments ? <div className="card marginLeftRightSmall marginTopMedium" style={{minHeight: "15em"}}>
                    <Score {...props} score={productComments.score}  product_id={product.product_id} count={productComments.count} suggest={productComments.suggest}/>

                    {productComments && productComments.list &&  productComments.list.length > 0 ?
                        <Comments {...props} comments={productComments.list} product_id={product.product_id} full={true} openImage={false} showDate={false} seeAll={true} hasImage={productComments.has_image}/>:<div></div>}
                </div>:<div></div>}

            </div>
        }
    }

    function basketPrice() {
        return <table>
            <tbody>
            <tr>
                {product.limit_count > 0 ?
                    <td>
                        <TitleValue
                            title={messages.price}
                            titleClassName="largeTextBold"
                            value={product.price}
                            valueClassName={product.special_price > 0 ?
                                "textUnderlined grayColor largeTextBold" :
                                "textNotUnderlined blueColor_2 largeTextBold"}
                            secondValue={product.special}
                            secondValueClassName={"blueColor_2 largeTextBold"}/>
                    </td> :
                    <td className="fullWidth">
                        <div className="paddingSmall pinkColor mediumTextBold">
                            {messages.productNotExist}
                        </div>
                    </td>
                }

                {product.limit_count > 0 &&
                    <td className="fullWidth">
                        <div className="horizontalScreen">
                            {product.is_old_price > 0 &&
                                <div style={{position: "relative"}} className="largeIcon center">
                                    <img src={ICTagBlue} className="full" alt=""/>
                                    <label className="whiteColor smallText productDetailTag">
                                        {messages.oldPrice}
                                    </label>
                                </div>
                            }
                            {product.discount_percent > 0 &&
                                <div style={{position: "relative"}} className="largeIcon center">
                                    <img src={ICTag} className="full" alt=""/>
                                    <label className="whiteColor mediumText productDetailTag">
                                        {product.discount_percent}%
                                    </label>
                                </div>
                            }
                        </div>
                    </td>
                }
            </tr>
            </tbody>
        </table>
    }

    function notExist() {
        return <>
            {product.limit_count > 0 ?
                <div className="marginSmall" style={{float: "left"}}>
                    {product.limit_count > 0 ?
                        <>
                            {isInBasket ?
                                <div>
                                    <Animated
                                        animationIn="slideInDown"
                                        animationInDuration={500}
                                        isVisible={isInBasket}>
                                        <div style={{width: "10em"}} className="center horizontalScreen">
                                            <StandardButton
                                                loading={plusProgressIsShow}
                                                icon={<img className={'xSmallIcon_1'} src={ICAddIcon} alt={"صرفه مارکت"}/>}
                                                onClick={() => {
                                                    if (basketCount >= product.limit_count) {
                                                        props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                                                    } else {
                                                        basketViewModel.plusToBasket(product, () => {

                                                        }, () => {

                                                        }, () => {
                                                            setPlusProgressIsShow(true)
                                                        }, () => {
                                                            setPlusProgressIsShow(false)
                                                        })
                                                    }
                                                }}/>
                                            <label style={{width: "40%", marginTop: "0.7em"}}
                                                   className="center largeTextBold blueColor_2 marginTopSmall">
                                                {basketCount}
                                            </label>
                                            <StandardButton
                                                loading={minusProgressIsShow}
                                                icon={<img className={'xSmallIcon_1'} src={ICRemoveIcon} alt={"صرفه مارکت"}/>}
                                                onClick={() => {
                                                    basketViewModel.removeFromBasket(product, () => {

                                                    }, () => {

                                                    }, () => {
                                                        setMinusProgressIsShow(true)
                                                    }, () => {
                                                        setMinusProgressIsShow(false)
                                                    })
                                                }}/>
                                        </div>
                                    </Animated>
                                </div> :
                                <div>
                                    <Animated
                                        animationIn="slideInDown"
                                        animationInDuration={500}
                                        isVisible={!isInBasket}>
                                        <IconTitleButtonRound
                                            backgroundcolor={"var(--red_3)"}
                                            height={"3em"}
                                            width={"100%"}
                                            direction="ltr"
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                if (product.basket_count >= product.limit_count) {

                                                } else {
                                                    basketViewModel.addToBasket(product, () => {

                                                    }, () => {

                                                    }, () => {
                                                        props.onLoading(true)
                                                    }, () => {
                                                        props.onLoading(false)
                                                    })
                                                }
                                            }}
                                            icon={<ICShoppingCartIcon
                                                className={'whiteColor'}
                                                fontSize={"small"}/>}
                                            title={messages.addToBasket}/>
                                    </Animated>
                                </div>
                            }
                        </> :
                        <>
                            {notifyStatus ?
                                <div>
                                    <Animated
                                        animationIn="slideInDown"
                                        animationInDuration={500}
                                        isVisible={!isInBasket}>
                                        <IconTitleButtonRound
                                            backgroundcolor={"var(--gray_4)"}
                                            height={"3em"}
                                            width={"100%"}
                                            direction="ltr"
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                requestNotifyProduct()
                                            }}
                                            icon={<ICMuteNotifications className={'whiteColor'}
                                                                       fontSize={"small"}/>}
                                            title={messages.dontNotifyMe}/>
                                    </Animated>
                                </div> :
                                <div>
                                    <Animated
                                        animationIn="slideInDown"
                                        animationInDuration={500}
                                        isVisible={!isInBasket}>
                                        <IconTitleButtonRound
                                            backgroundcolor={"var(--orange_1)"}
                                            height={"3em"}
                                            width={"100%"}
                                            direction="ltr"
                                            fontSize="mediumTextBold"
                                            onClick={() => {
                                                requestNotifyProduct()
                                            }}
                                            icon={<ICNotifications className={'whiteColor'}
                                                                   fontSize={"small"}/>}
                                            title={messages.notifyMe}/>
                                    </Animated>
                                </div>
                            }
                        </>
                    }
                </div> :
                <div className="halfWidth marginSmall" style={{float: "left"}}>
                    {notifyStatus ?
                        <div>
                            <Animated
                                animationIn="slideInDown"
                                animationInDuration={500}
                                isVisible={!isInBasket}>
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--gray_4)"}
                                    height={"3em"}
                                    width={"100%"}
                                    direction="ltr"
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        requestNotifyProduct()
                                    }}
                                    icon={<ICMuteNotifications className={'whiteColor'}
                                                               fontSize={"small"}/>}
                                    title={messages.dontNotifyMe}/>
                            </Animated>
                        </div> :
                        <div>
                            <Animated
                                animationIn="slideInDown"
                                animationInDuration={500}
                                isVisible={!isInBasket}>
                                <IconTitleButtonRound
                                    backgroundcolor={"var(--orange_1)"}
                                    height={"3em"}
                                    width={"100%"}
                                    direction="ltr"
                                    fontSize="mediumTextBold"
                                    onClick={() => {
                                        requestNotifyProduct()
                                    }}
                                    icon={<ICNotifications className={'whiteColor'}
                                                           fontSize={"small"}/>}
                                    title={messages.notifyMe}/>
                            </Animated>
                        </div>
                    }
                </div>
            }
        </>
    }

    function detailSmall() {
        if (product.images) {
            product.images = product.images.filter((image) =>
                image && image.length > 0
            )
        }
        return <>
            <div className="card marginSmall" style={{position: "relative"}}>
                <div className="largeTextBold marginSmall">
                    <br/>
                    {product.name}
                </div>
                <div className="marginTopMedium">
                    <Swiper
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: true,
                        }}
                        pagination={true}
                        modules={[Pagination]}>
                        {product.images.map((image, index) => {
                            return <SwiperSlide key={index} className="center">
                                <img style={{width: "50%"}}
                                     src={image}
                                     alt={"صرفه مارکت"}/>
                            </SwiperSlide>
                        })}
                    </Swiper>
                </div>
            </div>
            <div className="card marginSmall">
                {basketPrice()}
                {notExist()}
                <Divider style={{marginTop: "4em"}}/>
                {categoryPath()}
            </div>
        </>
    }

    function smallView() {

        if (product) {
            return <div className="fullWidth paddingTopSmall" style={{position: "relative"}}>
                {detailSmall()}
                {tabs()}
                {related()}

                {productComments ? <div className="card marginLeftRightSmall marginTopMedium" style={{minHeight: "15em"}}>

                        <Score score={productComments.score} {...props}  product_id={product.product_id} count={productComments.count} suggest={productComments.suggest}/>

                    {productComments && productComments.list &&  productComments.list.length > 0 ?
                        <Comments {...props} comments={productComments.list} openImage={false} product_id={product.product_id}  showDate={false} seeAll={true} full={false} hasImage={productComments.has_image
                        }/>:<div></div>}

                </div>: <div></div>}



            </div>
        }
    }

    function requestGetProductComments(){
        let params = new FormData();

        params.append("product_id",  urlParams.v);
        params.append("limit", 5);
        callApi(Urls.getProductComments, params, (response) => {
            if (response && response.result==='success' && response.response.list && response.response.list.length > 0) {
                setProductComments(response.response)
            }else{
                setProductComments([])
            }
        }, () => {
            props.onAlert(messages.responseCodeIsNot200)
        }, () => {
            // props.onLoading(true)
        }, () => {
            // props.onLoading(false)
        })
    }

    useEffect(() => {

        if (urlParams && urlParams.v) {
            requestProductDetail((product) => {
                if (isCancelled) return

                basketViewModel.product.subscribe(() => {
                    if (isCancelled) return

                    let localProducts = basketViewModel.getLocalBasket()
                    if (localProducts) {
                        if (product) {
                            let index = localProducts.findIndex((element) =>
                                element.product_id === product.product_id
                            )
                            if (index >= 0) {
                                setBasketCount(localProducts[index].basket_count)
                                setIsInBasket(true)
                            } else {
                                setBasketCount(0)
                                setIsInBasket(false)
                            }
                        }
                    } else {
                        setBasketCount(0)
                        setIsInBasket(false)
                    }
                })
            })
        }
        requestGetProductComments()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.search])

    return (<>
        {product &&
            <Helmet>
                <title>{product.name}صرفه مارکت -</title>
                <meta name="description" content={product.name}/>
                <meta property="og:title" content="{product.name}صرفه مارکت -"/>
                <meta property="og:description" content={product.name}/>
                <meta property="og:image" content="%PUBLIC_URL%/favicon.ico"/>
                <meta property="og:url" content="https://sarfemarket.ir/"/>
                <meta name="theme-color" content="#000000"/>
                <meta id="product_id" name="product_id" property="product_id" content={product.product_id}/>
                <meta id="product_name" name="product_name" property="product_name" content={product.name}/>
                <meta id="image" name="og:image" property="og:image" content={product.image}/>
                <meta id="product_price" name="product_price" property="product_price" content={product.price}/>
                <meta id="product_old_price" name="product_old_price" property="product_old_price"
                      content={product.special}/>
                <meta id="availability" name="availability" property="availability"
                      content={product.limit_count > 0 ? "instock" : "outofstock"}/>
                <meta name="google-site-verification" content="a7UDcP_j_QBlp1S7KGeczLTlvDmYkzvwyBo7Qa-qbH0"/>
            </Helmet>
        }
        {IsLP_MP_SP_T() ? largeView() : smallView()}
    </>)

}